import {
  InputWithLabelWrapper,
  StyledInput,
  TicketInfoLabel,
} from '../TicketInfoField/TicketInfoField.styled';
import React, { useId, useRef } from 'react';
interface TicketTypeFieldProps {
  ticketType: string | number;
  icon?: React.FC;
}

export const TypeField = ({ ticketType, icon }: TicketTypeFieldProps) => {
  const inputId = useId();
  const inputref = useRef<HTMLInputElement>();

  const TypeIcon = icon;

  const handleFocus = () => {
    if (inputref.current) {
      inputref.current?.blur();
    }
  };

  return (
    <InputWithLabelWrapper>
      <TicketInfoLabel htmlFor={inputId} size="medium">
        Ticket type
      </TicketInfoLabel>
      <StyledInput
        appearance="outline"
        size="medium"
        readOnly
        value={String(ticketType)}
        id={inputId}
        contentBefore={icon ? <TypeIcon /> : null}
        ref={inputref}
        onFocus={handleFocus}
      />
    </InputWithLabelWrapper>
  );
};
